<script>
export default {
  name: "riskConfig",
  data() {
    return {
      form: {
        status: 2,
        contactWay: 2
      },
      loading: false,
      rules: {}
    }
  },
  created() {
    this.getInitFn()
  },
  methods: {
    async getInitFn() {
      const url = "/api/v1/manage/hitchRide/risk/config"
      const {code, data} = await this.$axios.get(url)
      if (code === 1 && data) {
        this.form = {
          ...data,
          status: data.status ? data.status : 2,
          contactWay: data.contactWay ? data.contactWay : 2,
        }
      }
    },
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const url = "/api/v1/manage/hitchRide/risk/config"
          const data = await this.$axios.post(url, this.form);
          this.loading = false
          if (data && data.code === 1) {
            this.$message.success("保存成功！");
            this.getInitFn()
          }
        }
      });
    },
  }
}
</script>

<template>
  <div class="riskConfig">
    <div class="blueInfo util-remark">
      * 如频繁出现司机接单后私下联系客户取消订单跑私单的情况，可通过以下功能进行管控
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
      <div class="formTitle" style="margin: 20px 0 12px 0">司乘建联管控</div>
      <el-form-item label="限制司乘电联">
        <div>
          <div style="margin-bottom: 10px">
            <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
            <span class="util-remark"
                  style="display: inline-block; padding-left: 8px">开启后，在限制时间内将限制司机与乘客直接建立电话联系</span>
          </div>
          <div class="flex-start">
            <span style="margin-right: 10px">仅订单出发时间前</span>
            <el-form-item style="margin-bottom: 0" label-width="0" prop="contactTime"
                          :rules="[{ required: form.status === 1, message: '请输入建联时间', trigger: 'blur' }]">
              <el-input
                  v-model="form.contactTime"
                  maxlength="6"
                  v-input-filter="{ min: 1, max: 720, precision: 0 }"
                  placeholder=""
                  style="width: 205px"
              >
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>
            <span style="margin-left: 10px">允许司乘建联</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="司乘建联方式">
        <div class="flex-start" style="align-items: flex-start">
          <div style="margin-right: 12px">
            <el-radio v-model="form.contactWay" :label="1">平台客服建联</el-radio>
          </div>
          <div>
            <div class="flex-start">
              <span style="margin-right: 10px">车主联系乘客</span>
              <el-form-item style="margin-bottom: 0" label-width="0" prop="contactPassengerPhone"
                            :rules="[{ required: form.status === 1 && form.contactWay === 1, message: '请输入联系方式', trigger: 'blur' },{
                              pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请输入正确的联系方式', trigger: 'blur'
                            }]">
                <el-input
                    v-model="form.contactPassengerPhone"
                    placeholder=""
                    maxlength="11"
                    style="width: 205px"
                >
                </el-input>
              </el-form-item>
            </div>
            <div style="height: 12px"></div>
            <div class="flex-start">
              <span style="margin-right: 10px">乘客联系车主</span>
              <el-form-item style="margin-bottom: 0" label-width="0" prop="contactDriverPhone"
                            :rules="[{ required: form.status === 1 && form.contactWay === 1, message: '请输入联系方式', trigger: 'blur' },
                            { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请输入正确的联系方式', trigger: 'blur'}]"
              >
                <el-input
                    v-model="form.contactDriverPhone"
                    placeholder=""
                    maxlength="11"
                    style="width: 205px"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="">
        <div>
          <el-radio v-model="form.contactWay" :label="2">司机端IM建联</el-radio>
          <span class="util-remark">司机与乘客通过APP端内置的聊天工具进行联系</span>
        </div>
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" :loading="loading" @click="save">
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="less">

</style>